<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="カラーグループマスタ"
          icon="dashboard"
          class="masterColorGroup-header" />
      <span class="action_button">
        <div class="edit-button-wrap">
          <el-dropdown
              v-show="showActionButtonComponent"
              @command="actionCommand">
            <el-button size="small">
              アクション
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu
                slot="dropdown"
                class="header-action-menu">
              <el-dropdown-item
                  :disabled="$isFunctionDisabled(define.PermissionKeys.Master.ColorGroup.EDIT)"
                  :command="define.PRODUCT_COLOR_MODE.EDIT">
                編集
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <BaseButton v-show="showEditButton"
              @click="cancel()">
            キャンセル
          </BaseButton>
          <BaseButton v-show="showEditButton"
              :disabled="disableSaveButton"
              @click="save()">
            保存
          </BaseButton>
        </div>
      </span>
    </el-row>
    <BaseSearchConditionModal
        v-if="true"
        :no-condition="false"
        :keyword="searchKeyword"
        :is-and-search="isAndSearch"
        :conditions="searchConditions"
        :base-query="baseQuery"
        :store-path="storePath"
        :res-path="responsePath"
        :save-key="saveKey"
        @search="onSearch"
        @searched="onSearched" />
    <div class="base-table-list tab-list div-flex row-clickable-table">
      <div class="width-50">
        <el-row class="add-row">
          <BaseButton v-show="showEditButton"
              @click="addRow('group')">
            行追加
          </BaseButton>
        </el-row>
        <div class="el-table el-table--enable-row-hover">
          <div class="el-table__body-wrapper table_group">
            <table
                ref="table_group"
                class="table">
              <thead>
                <tr class="header">
                  <th class="is-leaf is-sortable width-30">カラーグループコード</th>
                  <th class="is-leaf is-sortable width-70">カラーグループ名</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(val, index) in colorGroupList">
                  <tr :key="index"
                      :data-id="`${index}`"
                      class="el-table__row"
                      :class="{'moveable': mode === define.PRODUCT_COLOR_MODE.EDIT,
                               'hidRow': val.node.isActive !== 1,
                               'tr-color': selectIndex === index}"
                      @click="onClick(index)">
                    <td>
                      <BaseCell
                          :ref="`code_${index}`"
                          :properties="createTextAreaProp('code')"
                          :display-item="val.node"
                          :editable="val.node.id === ''" />
                    </td>
                    <td>
                      <div class="div-flex">
                        <BaseCell
                            :ref="`name_${index}`"
                            :properties="createTextAreaProp('name')"
                            :display-item="val.node"
                            class="width-50"
                            :editable="mode === define.PRODUCT_COLOR_MODE.EDIT
                              && !groupUsed(val.node)" />
                        <BaseCell
                            v-if="mode === define.PRODUCT_COLOR_MODE.EDIT
                              && groupUsed(val.node)"
                            :ref="`name_${index}`"
                            class="cell-msg"
                            :properties="createTextAreaProp('used')"
                            :display-item="val.node"
                            :editable="false" />
                        <BaseOperationTooltip
                            v-if="showTooltip && !groupUsed(val.node) && !groupItemUsed(val.node)"
                            :list="getTooltipList(index, 'group')"
                            placement="bottom-end" />
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
              <tr v-if="colorGroupList.length < 1">
                <td colspan="3"
                    class="td-empty">
                  データなし
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="width-49">
        <el-row class="add-row">
          <BaseButton v-show="showEditButton"
              @click="addRow('color')">
            行追加
          </BaseButton>
        </el-row>
        <div class="el-table">
          <div class="el-table__body-wrapper table_color">
            <table
                ref="table_color"
                class="table">
              <thead>
                <tr class="header">
                  <th class="is-leaf is-sortable width-30">カラーコード</th>
                  <th class="is-leaf is-sortable width-70">カラー名</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="colorGroupList[selectIndex]">
                  <template v-for="(val, index) in colorGroupList[selectIndex].node.colorGroupItems">
                    <tr :key="index"
                        :data-id="`${index}`"
                        :class="{'moveable': mode === define.PRODUCT_COLOR_MODE.EDIT,
                                 'hidRow': val.isActive !== 1}">
                      <td>
                        <BaseCell
                            :ref="`code_${index}`"
                            :properties="createTextAreaProp('colorCode')"
                            :display-item="val"
                            :editable="mode === define.PRODUCT_COLOR_MODE.EDIT
                              && (!colorUsed(val) || !groupUsed(colorGroupList[selectIndex].node))"
                            @change="(after) => onChange(after, index)" />
                      </td>
                      <td>
                        <div class="div-flex">
                          <BaseCell
                              :ref="`name_${index}`"
                              :properties="createTextAreaProp('colorName')"
                              :display-item="val"
                              class="width-50"
                              :class="{'colorCode-adjustment': mode === define.PRODUCT_COLOR_MODE.EDIT
                                && (!colorUsed(val) || !groupUsed(colorGroupList[selectIndex].node)) }"
                              :editable="mode === define.PRODUCT_COLOR_MODE.EDIT
                                && (!colorUsed(val) || !groupUsed(colorGroupList[selectIndex].node))" />
                          <BaseCell
                              v-if="mode === define.PRODUCT_COLOR_MODE.EDIT
                                && (colorUsed(val) && groupUsed(colorGroupList[selectIndex].node))"
                              :ref="`name_${index}`"
                              class="cell-msg"
                              :properties="createTextAreaProp('itemused')"
                              :display-item="val.node"
                              :editable="false" />
                          <BaseOperationTooltip
                              v-if="showTooltip && (!colorUsed(val) || !groupUsed(colorGroupList[selectIndex].node))"
                              :list="getTooltipList(index, 'color')"
                              placement="bottom-end" />
                        </div>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
              <tr v-if="!colorGroupList[selectIndex] || colorGroupList[selectIndex].node.colorGroupItems.length < 1">
                <td colspan="3"
                    class="td-empty">
                  データなし
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .add-row {
    text-align: right;
    height: 35px;
  }
  .tab-list {
    padding-top: 0px !important;
  }
  .table {
    width: 100%;
  }
  .th-bottom {
    border-bottom: 1px solid #ebeef5;
  }
  .moveable {
  cursor: pointer;
  }
  .hidRow {
  display: none;
  }
  .td-empty {
    text-align: center !important;
    color: #909399 !important;
  }
  .div-flex {
    display: flex;
    justify-content: space-between;
  }
  .colorCode-adjustment {
    margin-top :-2px;
  }
  .cell-msg {
    color: #e22908;
    text-align: right;
    margin-right: 10px;
  }
  .width-30 {
    width: 30%;
  }
  .width-50 {
    width: 50%;
  }
  .width-49 {
    width: 49%;
  }
  .width-70 {
    width: 70%;
  }
  .tr-color {
    background-color: #fcfbed !important;
  }
</style>
<script>
import _ from 'lodash'
import Sortable from 'sortablejs'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/master'
import common from '@/utils/common'
import compare from '@/utils/compareUtils'
import * as config from '@/config'
import message from '@/utils/message'

import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import BaseSearchConditionModal from '@/components/organisms/BaseSearchConditionModal'
import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import detailUtil from '@/components/mixins/detailUtil'

const colorValidationRules = (v) => {
  // カラーグループコードの重複チェック
  v.$validator.extend('groupCodeDuplicateCheck', {
    getMessage: () => '同じカラーグループコードが存在します',
    validate: (data) => {
      // 該当カラーグループコードはリストに既存の場合、エラーになる
      if (v.colorGroupList.filter((val, key) => { return val.node.code.toUpperCase() === data.toUpperCase() }).length > 1) {
        return false
      }
      return true
    }
  })
  // カラーグループコードの重複チェック
  v.$validator.extend('colorCodeDuplicateCheck', {
    getMessage: () => '同じカラーコードが存在します',
    validate: (data) => {
      // 該当カラーコードはリストに既存の場合、エラーになる
      if (v.colorGroupList[v.selectIndex].node.colorGroupItems.filter((val, key) => { return val.code.toUpperCase() === data.toUpperCase() }).length > 1) {
        return false
      }
      return true
    }
  })
}

export default {
  name: 'MasterColorGroupList',
  components: {
    BaseHeader,
    BaseCell,
    BaseButton,
    BaseSearchConditionModal,
    BaseOperationTooltip
  },
  mixins: [ x, confirmDiscardOnLeave, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      isChanged: false,
      selectIndex: 0,
      colorGroupList: [],
      originColorGroupList: [],
      colorNameList: [],
      sortGroupAble: Object,
      sortColorAble: Object
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      mode: (state) => state.MasterColorGroup.mode,
      searchKeyword: (state) => state.MasterColorGroup.searchKeyword,
      isAndSearch: (state) => state.MasterColorGroup.isAndSearch,
      searchConditions: (state) => state.MasterColorGroup.searchConditions,
      tdLists: (state) => state.MasterColorGroup.tdLists
    }),
    ...mapGetters({
    }),
    saveKey () {
      return 'masterColorCondition'
    },
    storePath () {
      return 'MasterColorGroup'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_PRODUCT_COLORGROUP_LIST
    },
    responsePath () {
      return 'data.colorGroupListItems.edges'
    },
    showActionButtonComponent () {
      return (this.showActionButton && (this.$isFunctionShown(define.PermissionKeys.Master.ColorGroup.EDIT)))
    },
    showTooltip () {
      return this.mode !== define.PRODUCT_COLOR_MODE.NORMAL
    },
    showActionButton () {
      return this.mode === define.PRODUCT_COLOR_MODE.NORMAL
    },
    showEditButton () {
      return this.mode !== define.PRODUCT_COLOR_MODE.NORMAL
    },
    disableSaveButton () {
      return !this.isChanged
    },
    editableValidIds () {
      return this.mode !== define.PRODUCT_COLOR_MODE.NORMAL
    }
  },
  watch: {
    colorGroupList: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    mode: {
      handler: function (val, oldVal) {
        if (oldVal != null) {
          // 通常モード ==> 編集モードの場合
          if (val === define.PRODUCT_COLOR_MODE.EDIT) {
            // 編集モードに切り替える場合
            this.originColorGroupList = _.cloneDeep(this.colorGroupList)
            // ソート出来るグループTABLEを設定する
            this.createGroupSortTable()
            // ソート出来るカラーTABLEを設定する
            this.createColorSortTable()
            this.$_ConfirmDiscardOnLeave_watchStart(this.colorGroupList)
          } else {
            // 編集モード ==> 通常モードの場合
            this.selectIndex = 0
            if (this.sortGroupAble) {
              // 通常モードに切り替える場合
              this.sortGroupAble.sort(this.sortGroupAble.toArray().map(Number).sort((a, b) => a - b))
              // ソート出来るTABLEを削除
              this.sortGroupAble.destroy()
            }
            if (this.sortGroupAble) {
              // 通常モードに切り替える場合
              this.sortColorAble.sort(this.sortColorAble.toArray().map(Number).sort((a, b) => a - b))
              // ソート出来るTABLEを削除
              this.sortColorAble.destroy()
            }
            this.$_ConfirmDiscardOnLeave_watchEnd()
          }
        }
      },
      deep: true
    }
  },
  async created () {
    this.updateStore('mode', define.PRODUCT_COLOR_MODE.NORMAL)
    // 画面初期化する時に、一覧リストを取得する
    await this.getDetailData()

    await this.getColorMaster()
    // カスタムバリデーションルールを追加
    colorValidationRules(this)
  },
  mounted () {
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  methods: {
    onChange (event, index) {
      const checkName = this.colorNameList.find((element) => element.code === event)
      if (checkName != null) {
        this.colorGroupList[this.selectIndex].node.colorGroupItems[index].name = checkName.name
      }
    },

    /**
     * 行クリック
     */
    async onClick (index) {
      // チェック処理（選択する前に既存のデータをチェックする）
      if (!await this.$validator.validate()) {
        return
      }
      // 行選択を設定
      this.selectIndex = index
      // フォーカス移動
      window.scroll({ top: this.$refs['table_color'].offsetTop, behavior: 'smooth' })
    },
    /**
     * グループドラッグTableを作成
     */
    createGroupSortTable (oldIndex, newIndex) {
      // ソート対象テーブルを取得する
      const tbody = document.querySelector('.table_group tbody')
      if (tbody == null) {
        return
      }
      // ソートテーブルを生成
      this.sortGroupAble = Sortable.create(tbody, {
        animation: 180,
        delay: 0,
        disabled: false,
        onEnd: evt => {
          // ソートした後、カラーリストのINDEXを再計算する
          this.sortGroupIndex(this.sortGroupAble.toArray())
        }
      })
    },
    /**
     * ドラッグした場合、グループリストにのソートを再計算する.
     */
    sortGroupIndex (sortOrder) {
      for (let i = 0; i < this.colorGroupList.length; i++) {
        const index = sortOrder.map(Number).indexOf(i)
        this.colorGroupList[i].node.displayOrder = index + 1
      }
    },
    /**
     * カラードラッグTableを作成
     */
    createColorSortTable (oldIndex, newIndex) {
      // ソート対象テーブルを取得する
      const tbody = document.querySelector('.table_color tbody')
      if (tbody == null) {
        return
      }
      // ソートテーブルを生成
      this.sortColorAble = Sortable.create(tbody, {
        animation: 180,
        delay: 0,
        disabled: false,
        onEnd: evt => {
          // ソートした後、カラーリストのINDEXを再計算する
          this.sortColorIndex(this.sortColorAble.toArray())
        }
      })
    },
    /**
     * ドラッグした場合、カラーリストにのソートを再計算する.
     */
    sortColorIndex (sortOrder) {
      for (let i = 0; i < this.colorGroupList[this.selectIndex].node.colorGroupItems.length; i++) {
        const index = sortOrder.map(Number).indexOf(i)
        this.colorGroupList[this.selectIndex].node.colorGroupItems[i].displayOrder = index + 1
      }
    },
    onSearch (keyword, conditions) {
      this.$emit('search', keyword, conditions)
    },
    onSearched (result) {
      // 検索後、データを再取得、通常モードに戻る
      this.$emit('searched', result)
      this.colorGroupList = this.tdLists
      // ディフォルト行選択に０を設定
      this.selectIndex = 0
      // 再検索後、通常モードに切り替える
      this.updateStore('mode', define.PRODUCT_COLOR_MODE.NORMAL)
    },
    /**
     * productマスタに使用中かをチェックする.
     */
    groupUsed (node) {
      // productマスタにサイズグループコードに紐づくレコードがある場合、使用中とみなす
      return node.productExists
    },

    /**
     * skuマスタに使用中かをチェックする.
     */
    colorUsed (node) {
      // skuマスタにサイズグループコードに紐づくレコードがある場合、使用中とみなす
      return node.skuExists
    },

    groupItemUsed (node) {
      // カラーグループ詳細にレコードがある場合、使用中とみなす
      return node.colorGroupItems.length > 0
    },

    /**
     * 画面一覧項目を生成.
     * @param {Object} path 項目キー
     */
    createTextAreaProp (path) {
      // カラーグループコード
      if (path === 'code') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'required|max:50|groupCodeDuplicateCheck', validateAs: 'カラーグループコード'
        }
      }
      // カラーグループ名
      if (path === 'name') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'max:256', validateAs: 'カラーグループ名'
        }
      }
      // カラーコード
      if (path === 'colorCode') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX,
          path: 'code', validateRule: 'required|max:50|colorCodeDuplicateCheck', validateAs: 'カラーコード',
          selectCode: () => _.map(this.colorNameList, val => ({ code: val.code, name: val.code })),
          codeName: (code) => {
            return (this.colorNameList.find(element => code === element.code) || {}).code
          }

        }
      }
      // カラー名
      if (path === 'colorName') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: 'name', validateRule: 'max:256', validateAs: 'カラー名'
        }
      }
      // 使用中文字
      if (path === 'used') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT,
          path: '商品マスタに利用されています', class: { bold: true, center: true }
        }
      }
      // 使用中文字
      if (path === 'itemused') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT,
          path: 'SKUマスタに利用されています', class: { bold: true, center: true }
        }
      }
    },
    /**
     * グループTooltipの項目を返却する.
     * @param {Object} row 注文情報
     * @return {Array}
     */
    getTooltipList (index, type) {
      return [
        {
          title: '削除',
          click: () => this.delete(index, type)
        }
      ]
    },
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },

    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.PRODUCT_COLOR_MODE.EDIT:
          this.editColor()
          break
        default: {}
      }
    },

    /**
     * EDIT処理
     */
    async editColor () {
      // 編集モードは全検索は前提です
      if (this.searchKeyword !== '') {
        // 検索条件がある場合、確認メッセージを出す
        this.$confirm('編集モードでは全件表示されます', define.MESSAGE_TITLE, {
          confirmButtonText: 'OK',
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(async () => {
          // OKの場合、検索条件をクリアして、再検索を行う
          await this.updateStore('searchKeyword', '')
          await this.updateStore('isAndSearch', false)
          // 再検索を行う
          await this.getDetailData()
          await this.getColorMaster()
          // 編集モードに切り替える
          this.updateStore('mode', define.PRODUCT_COLOR_MODE.EDIT)
        }).catch(() => {
          this.$notify.info('キャンセルしました。')
        })
      } else {
        // そもそもが全検索の場合、そのまま編集モードに切り替える
        this.updateStore('mode', define.PRODUCT_COLOR_MODE.EDIT)
      }
    },
    /**
     * 新規カラーグループ行を生成.
     */
    addRow (type) {
      if (type === 'group') {
        // グループ行追加の場合
        this.colorGroupList.push({ node: { id: '', isActive: 1, displayOrder: '', code: '', name: '', colorGroupItems: [], productExists: 0 } })
        // 追加した行を選択
        this.onClick(this.colorGroupList.length - 1)
        // フォーカス移動
        window.scroll({ top: this.$refs['table_group'].offsetHeight, behavior: 'smooth' })
      } else {
        // カラー行追加の場合
        this.colorGroupList[this.selectIndex].node.colorGroupItems.push({ id: '', isActive: 1, displayOrder: '', code: '', name: '', skuExists: 0 })
        // フォーカス移動
        window.scroll({ top: this.$refs['table_color'].offsetHeight, behavior: 'smooth' })
      }
    },
    /**
     * グループ削除を行う
     * @param {Number} index インデックス
     */
    delete (index, type) {
      if (type === 'group') {
        // グループ行を削除する場合
        if (this.colorGroupList[index].node.id === '') {
          // 追加行の場合、そのまま削除する
          this.colorGroupList.splice(index, 1)
        } else {
          // 既存行の場合、削除フラグに０を更新する
          this.colorGroupList[index].node.isActive = 0
        }
      } else {
        // カラー行を削除する場合
        if (this.colorGroupList[this.selectIndex].node.colorGroupItems[index].id === '') {
          // 追加行の場合、そのまま削除する
          this.colorGroupList[this.selectIndex].node.colorGroupItems.splice(index, 1)
        } else {
          // 既存行の場合、削除フラグに０を更新する
          this.colorGroupList[this.selectIndex].node.colorGroupItems[index].isActive = 0
        }
      }
    },
    /**
     * カラーグループ編集保存を行う
     */
    async save () {
      // チェック処理
      if (!await this.$validator.validate()) {
        return
      }

      // 保存を行う
      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // カラー編集パラメータの作成
          const data = this.buildRequestForUpdate()
          // カラー編集保存を行う
          await this.updateColorGroupApi(data)
          this.isChanged = false
          // 編集保存後、通常モードに切り替える
          this.updateStore('mode', define.PRODUCT_COLOR_MODE.NORMAL)
          // 保存後、リスト再検索を行う
          await this.getDetailData()
          await this.getColorMaster()
          this.$notify.success('保存しました。')
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            // システムエラー
            common.addError(error, { msg: message.MSG_502() })
          } else {
            // APIエラー
            common.addError(error, { msg: message.MSG_542() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    /**
     * カラー編集キャンセルを行う
     */
    async cancel () {
      const cancelEdit = () => {
        // 通常モードに切り替える
        this.updateStore('mode', define.PRODUCT_COLOR_MODE.NORMAL)
        this.isChanged = false
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm('カラーグループ変更を破棄しますか？',
        define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }
      ).then(() => {
        // キャンセル後、リスト再検索を行う
        this.getDetailData()
        this.getColorMaster()
        cancelEdit()
      }).catch(() => {
      })
    },
    /**
     * カラーグループ情報を取得する。
     */
    async getDetailData () {
      try {
        this.$loadingService.show()
        // 検索SQLを作成する
        const queryQL = common.addGraphQlCondition(query.GRAPH_QL_QUERY_PRODUCT_COLORGROUP_LIST, { keyword: this.searchKeyword })
        // カラー検索APIを呼び出す
        const res = await common.postGraphQl(queryQL)
        // DBから画面の情報を取得
        this.colorGroupList = res.data.data.colorGroupListItems.edges
        this.originColorGroupList = _.cloneDeep(this.colorGroupList)
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },

    async getColorMaster () {
      let res = await common.postGraphQl(query.GRAPH_QL_QUERY_COLOR_MASTER, { isMessageControl: true })
      this.colorNameList = res.data.data.colors
    },

    /**
     * 一覧 からカラー更新APIのリクエストパラメータを作成する.
     * originDataとの差分のみ戻り値とする.
     */
    buildRequestForUpdate () {
      let requestData = []
      // 差分レコードを取得
      const diffList = compare.diff(this.originColorGroupList, this.colorGroupList)
      for (const index in diffList) {
        const groupItem = this.colorGroupList[index].node
        // カラー情報の生成
        const colorGroupItems = []
        for (const itemIndex in diffList[index].node.colorGroupItems) {
          const colorItem = groupItem.colorGroupItems[itemIndex]
          colorGroupItems.push(
            {
              itemIndex: colorItem.displayOrder, // カラーコード
              itemUuid: colorItem.uuid, // uuid
              itemCode: colorItem.code, // カラー名
              itemName: colorItem.name, // カラー表示順
              delete: colorItem.isActive === 0 ? 1 : 0 // 有効フラグ（有効）
            })
        }
        // グループ情報を生成
        requestData.push(
          {
            groupCode: groupItem.code, // グループコード
            groupName: groupItem.name, // グループ名
            groupIndex: groupItem.displayOrder, // グループ表示順
            delete: groupItem.isActive === 0 ? 1 : 0, // 有効フラグ（有効）
            colorGroupItems: colorGroupItems
          })
      }
      return requestData
    },
    /**
     * カラー更新 APIを呼び出す
     */
    async updateColorGroupApi (requestData) {
      const data = {
        colorGroups: requestData
      }
      const url = config.PRODUCT_COLORGROUP_URL
      const method = 'post'
      const response = await common.apiAxios(url, { method, data })
      return response
    },
    /**
     * ストアの情報を更新する
     */
    updateStore (key, val) {
      const storeKey = `MasterColorGroup/${key}`
      this.$store.commit({
        type: 'set',
        states: {
          [storeKey]: val
        }
      })
    }
  }
}
</script>
